// CustomPagination.js
import React, { useState } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import './CustomPagination.css';

const CustomPagination = ({
    currentPage,
    totalPages,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    totalRecords
}) => {
    const [isEditingRowsPerPage, setIsEditingRowsPerPage] = useState(false);
    const [tempRowsPerPage, setTempRowsPerPage] = useState(rowsPerPage);

    // Calculate the starting and ending row numbers for the current page
    const startRow = (currentPage - 1) * rowsPerPage + 1;
    const endRow = Math.min(currentPage * rowsPerPage, totalRecords);

    const handleRowsPerPageClick = () => {
        setIsEditingRowsPerPage(true);
        setTempRowsPerPage("");
    };

    const handleRowsPerPageChange = (e) => {
        const value = parseInt(e.target.value, 10);
        setTempRowsPerPage(value);
    };

    const handleRowsPerPageBlur = () => {
        setIsEditingRowsPerPage(false);
        if (tempRowsPerPage > 0 && !isNaN(tempRowsPerPage)) {
            onRowsPerPageChange(tempRowsPerPage);
        }
    };

    const handleRowsPerPageKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleRowsPerPageBlur();
        }
    };

    return (
        <div className="custom-pagination">
            {/* Display the current row range */}
            <span className="row-range">
                {startRow} -{' '}
                {isEditingRowsPerPage ? (
                    <input
                        type="number"
                        min="1"
                        value={tempRowsPerPage}
                        onChange={handleRowsPerPageChange}
                        onBlur={handleRowsPerPageBlur}
                        onKeyPress={handleRowsPerPageKeyPress}
                        autoFocus
                        className="rows-per-page-input"
                    />
                ) : (
                    <span onClick={handleRowsPerPageClick} className="end-row">
                        {endRow}
                    </span>
                )}
            </span>

            {/* Display total number of records */}
            <span className="total-records">/{totalRecords}</span>

            {/* Navigation buttons */}
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-button"
            >
                <FaArrowLeft />
            </button>

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="pagination-button-right"
            >
                <FaArrowRight />
            </button>
        </div>
    );
};

export default CustomPagination;
